import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const getAllVariables = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/variableList', METHOD_TYPES.GET, data, callback);
};

export const createVariable = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/variable', METHOD_TYPES.POST, data, callback);
};

export const updateVariable = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/variable', METHOD_TYPES.PUT, data, callback);
};

export const deleteVariable = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/variable', METHOD_TYPES.DELETE, data, callback);
};

export const getAllActions = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/brandFunction', METHOD_TYPES.GET, data, callback);
};

export const createAction = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/brandFunction', METHOD_TYPES.POST, data, callback);
};

export const updateAction = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/brandFunction', METHOD_TYPES.PUT, data, callback);
};

export const deleteAction = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/brandFunction', METHOD_TYPES.DELETE, data, callback);
};


// WEBPACK FOOTER //
// ./src/data/redux/botparams_details/api.js